'use client'

import { useEffect, useSyncExternalStore } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { estaBloqueada, ouvirRedeBloqueada } from '@/lib/auth/redeBloqueada'
import { sairPorSessaoMorta } from '@/lib/auth/saida'
import { useAuth } from '@/providers/AuthContext'
import { TelaDeRedeBloqueada } from './TelaDeRedeBloqueada'

const NUNCA_NO_SERVIDOR = () => false

/**
 * A tela de bloqueio por rede com o app ABERTO (faixa 28 §4). Ver `BloqueioDeRede.md`. Irmã da árvore: os filhos
 * continuam montados. Ao apagar o bloqueio (venha de onde vier), refaz SÓ as consultas que falharam.
 */
export function BloqueioDeRede() {
  const bloqueada = useSyncExternalStore(ouvirRedeBloqueada, estaBloqueada, NUNCA_NO_SERVIDOR)
  const queryClient = useQueryClient()
  const { logout } = useAuth()

  useEffect(
    () =>
      ouvirRedeBloqueada(() => {
        if (estaBloqueada()) return
        // `refetchOnWindowFocus` está desligado (`QueryProvider`): sem isto a tela atrás ficaria no erro do 403.
        void queryClient.invalidateQueries({ predicate: (query) => query.state.status === 'error' })
      }),
    [queryClient],
  )

  if (!bloqueada) return null
  return <TelaDeRedeBloqueada aoPerderSessao={sairPorSessaoMorta} aoSair={logout} />
}
